<template>
  <div class="chart-component">
    <e-chart
      ref="chart"
      :key="chartKey"
      :options="chartOptions"
      autoresize
      style="height: 200px;"
    />
    <div class="chart-value">{{ typeof amount === 'number' ? amount.toLocaleString() : amount }}</div>
    <div class="chart-percent">{{ percentage }}%</div>
  </div>
</template>

<script>
import ECharts from 'vue-echarts'
import 'echarts/lib/chart/gauge'
import 'echarts/lib/component/tooltip'
import 'echarts/lib/component/legend'

export default {
  props: {
    amount: {
      type: [Number, String],
    },
    percentage: {
      type: Number,
      default: 87.5,
    },
  },
  components: {
    'e-chart': ECharts,
  },
  data: () => ({
    chartKey: 1,
  }),
  watch: {
    percentage: {
      handler() {
        this.chartKey += 1
      },
      deep: true,
      immediate: true,
    },
  },
  computed: {
    chartOptions() {
      return {
        series: [
          {
            type: 'gauge',
            startAngle: 180,
            endAngle: 0,
            radius: '100%',
            center: ['50%', '75%'],
            progress: {
              show: true,
              width: 14,
              itemStyle: {
                color: '#6C70FF',
              },
            },
            axisLine: {
              lineStyle: {
                width: 14,
                color: [
                  [this.percentage / 100, '#6C70FF'],
                  [1, '#F0F0F0'],
                ],
              },
            },
            axisTick: {
              show: false,
            },
            splitLine: {
              show: false,
            },
            axisLabel: {
              show: false,
            },
            pointer: {
              show: false,
            },
            detail: {
              show: false,
            },
            data: [{ value: this.percentage }],
          },
        ],
      }
    },
  },
}
</script>

<style scoped lang="scss">
.chart-component {
  width: fit-content;
  max-width: 300px;
  text-align: center;
  position: relative;
  .echarts {
    width: 250px;
    display: flex;
    justify-content: center;
  }
  .chart-header {
    font-weight: 700;
    font-size: 20px;
    margin-bottom: 10px;
    color: #1c2b36;
  }
  .chart {
    height: 160px;
  }
  .chart-value {
    position: absolute;
    top: 90px;
    left: 50%;
    transform: translateX(-50%);
    font-size: 20px;
    font-weight: 700;
    color: #1c2b36;
  }
  .chart-percent {
    position: absolute;
    bottom: 50px;
    left: 50%;
    transform: translateX(-50%);
    display: inline-block;
    background-color: #e9fdf1;
    color: #27ae60;
    font-weight: 600;
    font-size: 12px;
    padding: 2px 12px;
    border-radius: 16px;
  }
}
</style>
